import { Swiper, SwiperSlide } from "swiper/react";
import { NEWS_BANNER_INFO } from "assets/json/newsInfo.js";
import { URL } from "../../utils/Utils";

// Import Swiper styles start
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
// Import Swiper styles end

/**
 * @file 최신뉴스 화면에서의 배너 영역의 swiper
 */
function NewsBannerSwiper() {
  const settings = {
    className: "swiper-news-wrapper",
    direction: "horizontal",
    slidesPerView: "auto", // 한 화면에 보이는 슬라이드 수
    loop: true,
  };

  return (
    <div className="swiper-news-wrapper">
      <div className="swiper-wrapper">
        <Swiper {...settings}>
          {NEWS_BANNER_INFO.map((val, i) => (
            <SwiperSlide
              className="swiper-slide"
              style={{ backgroundImage: `url(${val.imgUrl})` }}
              key={"news-banner-" + i}
            >
              <div className="text-box">
                <div
                  className="t1"
                  style={{ color: val.titleColor }}
                  dangerouslySetInnerHTML={{ __html: val.title }}
                ></div>
                <div className="sub" style={{ color: val.subColor }}>
                  {val.sub}
                </div>
                <a
                  className="link"
                  href={URL.NEWS.BOARD_DETAIL + URL.SEARCH_ID + val.id}
                  style={{
                    backgroundColor: val.btnBgColor,
                    color: val.btnTextColor,
                  }}
                >
                  더 알아보기
                </a>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default NewsBannerSwiper;
